__webpack_require__.p = "/workspace-configs-cleanup/system-email-templates/";